import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import OpenCloseIndication from './OpenCloseIndication.js';
import { getOpenCloseStatus, getOpenCloseIndication } from '../../utils/location-utils.js';

const OpenCloseIndicationContainer = (_param)=>{
    var { openingHours , specialOpeningHours , onExpand  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "openingHours",
        "specialOpeningHours",
        "onExpand"
    ]);
    const [mounted, setMounted] = React.useState(false);
    const [time, setTime] = React.useState(Date.now());
    const { dateTime , getLabel  } = useIntl();
    const status = React.useMemo(()=>getOpenCloseStatus(openingHours, specialOpeningHours)
    , [
        // when the time state is set, it should trigger re-memoization
        time,
        openingHours,
        specialOpeningHours, 
    ]);
    const indication = React.useMemo(()=>getOpenCloseIndication(openingHours, specialOpeningHours, dateTime.formatTime)
    , // when the time state is set, it should trigger re-memoization
    [
        time,
        openingHours,
        specialOpeningHours,
        dateTime.formatTime
    ]);
    const labels = React.useMemo(()=>({
            status: getLabel(`locations.openCloseIndication.status.${status}`),
            indication: indication.opensAt ? getLabel(`locations.openCloseIndication.indication.${indication.opensAt}`) : ''
        })
    , // when the time state is set, it should trigger re-memoization
    [
        time,
        getLabel,
        indication.opensAt,
        status
    ]);
    React.useEffect(()=>{
        const interval = setInterval(()=>{
            setTime(Date.now());
        }, 60000);
        return ()=>{
            clearInterval(interval);
        };
    }, []);
    React.useEffect(()=>{
        setMounted(true);
    }, []);
    const onKeyDown = React.useCallback((event)=>{
        if (!onExpand) {
            return;
        }
        switch(event.key){
            case 'ArrowLeft':
                onExpand(false);
                break;
            case 'ArrowRight':
                onExpand(true);
                break;
        }
    }, [
        onExpand
    ]);
    return mounted ? /*#__PURE__*/ React.createElement(OpenCloseIndication, swcHelpers.extends({}, rest, {
        labels: labels,
        status: status,
        hours: indication.hours,
        onExpand: onExpand,
        onKeyDown: onKeyDown
    })) : null;
};
var OpenCloseIndicationContainer$1 = OpenCloseIndicationContainer;

export { OpenCloseIndicationContainer$1 as default };
//# sourceMappingURL=OpenCloseIndicationContainer.js.map
